export default {
  methods: {
    outMsg(type, errMsg, errObj) {
      if (errObj && errObj.message) {
        this.$jcNotify({
          message: errObj.message,
          type: type,
        })
      } else {
        this.$jcNotify({
          message: errMsg,
          type: type,
          duration: 3000,
        })
      }
    },
  },
}
